const ApolloClient = require('apollo-client').default;
const { BatchHttpLink } = require('apollo-link-batch-http');
const { InMemoryCache } = require('apollo-cache-inmemory');

const getGraphQLFragmentMatcher = require('./getGraphQLFragmentMatcher');

const DEFAULT_LINK_OPTIONS = {
  credentials: 'include',
  batchInterval: 30
};

/**
 * @param {string} uri
 * @param {string} name app name
 * @param {string} version app version
 * @param {Object} cacheValue graphql cache
 * @param {Object} linkOptions https://www.apollographql.com/docs/link/
 * @memberof module:@sm/utils
 * @returns {ApolloClient} ApolloClient
 * @example
 * const foo = getGraphQLClientForBrowser('/graphql'); - will use default auth
 * const bar = getGraphQLClientForBrowser('/lo-graphql', {
 *      credentials: false,
 *      headers: {
 *          'X-Header': 'zzz'
 *      }
 *   }); - will ignore auth and add custom headers
 */
const getGraphQLClientForBrowser = (
  uri,
  name,
  version,
  cacheValue,
  linkOptions = {}
) => {
  const cache = new InMemoryCache({
    fragmentMatcher: getGraphQLFragmentMatcher()
  }).restore(cacheValue);

  const linkOpts = { ...DEFAULT_LINK_OPTIONS, ...linkOptions, uri };
  const link = new BatchHttpLink(linkOpts);

  const clientOpts = {
    shouldBatch: true,
    connectToDevTools: true,
    cache,
    link,
    name,
    version
  };

  return new ApolloClient(clientOpts);
};

module.exports = getGraphQLClientForBrowser;
